import type { AlertLevel, GaugeFeatureCollection } from "../api.ts";
import { RAIN_LIGHT, RAIN_MODERATE, RAIN_HEAVY } from "../map/map-colors.ts";

const LEVEL_RANK: Record<AlertLevel, number> = {
  normal: 0,
  watch: 1,
  high: 2,
};

function worstLevel(collection: GaugeFeatureCollection): AlertLevel {
  let worst: AlertLevel = "normal";
  for (const f of collection.features) {
    const level = (f.properties.alert_level ?? "normal") as AlertLevel;
    if (LEVEL_RANK[level] > LEVEL_RANK[worst]) worst = level;
  }
  return worst;
}

type RainfallIntensity = "dry" | "light" | "moderate" | "heavy";

function worstRainfallIntensity(rainfall: GaugeFeatureCollection): RainfallIntensity {
  let max = 0;
  for (const f of rainfall.features) {
    const v = f.properties.value ?? 0;
    if (v > max) max = v;
  }
  if (max >= RAIN_HEAVY)    return "heavy";
  if (max >= RAIN_MODERATE) return "moderate";
  if (max >= RAIN_LIGHT)    return "light";
  return "dry";
}

const INTENSITY_CLASS: Record<RainfallIntensity, string> = {
  dry:      "rain-dry",
  light:    "rain-light",
  moderate: "rain-moderate",
  heavy:    "rain-heavy",
};

export function updateAlertPanel(
  rainfall: GaugeFeatureCollection,
  river: GaugeFeatureCollection,
): void {
  const rainfallBadge = document.getElementById("rainfall-status");
  const riverBadge = document.getElementById("river-status");
  const lastUpdated = document.getElementById("last-updated");

  const intensity = worstRainfallIntensity(rainfall);
  const riverLevel = worstLevel(river);

  if (rainfallBadge) {
    rainfallBadge.className = `alert-badge ${INTENSITY_CLASS[intensity]}`;
    rainfallBadge.textContent = `Rainfall: ${intensity}`;
  }

  if (riverBadge) {
    riverBadge.className = `alert-badge ${riverLevel}`;
    riverBadge.textContent = `Rivers: ${riverLevel}`;
  }

  if (lastUpdated) {
    lastUpdated.textContent = `Updated ${new Date().toLocaleTimeString("en-NZ")}`;
  }
}
